import { useNavigate } from "react-router-dom";

const features = [
  { icon: "ri-shield-check-line", title: "Trade Assurance", desc: "Your payment is protected until you confirm delivery. Full refund if products don't match." },
  { icon: "ri-truck-line", title: "Fast Global Shipping", desc: "Integrated logistics with 50+ carriers. Real-time tracking from factory to your door." },
  { icon: "ri-verified-badge-line", title: "Verified Suppliers", desc: "Every supplier is background-checked, factory-audited, and quality-certified." },
  { icon: "ri-customer-service-2-line", title: "24/7 Trade Support", desc: "Dedicated trade specialists available around the clock in 20+ languages." },
];

export default function TrustSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-white">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-amber-500 text-sm font-semibold uppercase tracking-widest mb-2">Why CrownGlobal</p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Trade with Confidence</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">We protect every transaction with industry-leading security, verified suppliers, and end-to-end support.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {features.map((f) => (
            <div
              key={f.title}
              className="group p-6 rounded-xl border border-gray-100 bg-gray-50 hover:bg-amber-400 transition-colors duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 group-hover:bg-white/20 rounded-xl mb-4 transition-colors">
                <i className={`${f.icon} text-amber-500 group-hover:text-white text-2xl transition-colors`}></i>
              </div>
              <h3 className="font-bold text-gray-900 group-hover:text-white text-base mb-2 transition-colors">{f.title}</h3>
              <p className="text-gray-500 group-hover:text-white/80 text-sm leading-relaxed transition-colors">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/63dac688a51229a1502934d06fe852ed.jpg"
            alt="Trade Partnership"
            className="w-full h-64 md:h-80 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col justify-center px-8 md:px-16">
            <h3 className="text-white text-2xl md:text-4xl font-extrabold mb-3 max-w-lg">Ready to Scale Your Global Business?</h3>
            <p className="text-white/80 text-sm md:text-base mb-6 max-w-md">Join 20 Million+ factories and 600 Million+ buyers already trading on CrownGlobal.</p>
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => navigate("/marketplace")}
                className="bg-amber-400 hover:bg-amber-500 text-white font-bold px-6 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Start Sourcing
              </button>
              <button
                onClick={() => navigate("/vendor-dashboard")}
                className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold px-6 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Become a Supplier
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
